module.exports = require("../../version/ServerDisplay.vue");